function useWatermark(state) {
  if (state && state.name !== undefined) {
    return state.name;
  } else if (state && state.group && state.meter && !state.charge) {
    return `${state.meter.name.slice(0, 3)}/${state.group.name}`;
  } else if (state && state.group && state.charge && state.meter) {
    return `${state.meter.name.slice(0, 3)}/${state.group.name.slice(0, 3)}/${state.charge.name}`;
  } else {
    return 'MI MEDICIÓN';
  }
}

export default useWatermark;
